import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'array',
    standalone: false
})
export class ArrayPipe implements PipeTransform {

    transform(start: number, end: number): any {
        const array = [];

        for (let i = start; i <= end; i++) {
            array.push(i);
        }

        return array;
    }

}
